import { fetchWrapper } from "../utils/fetch-wrapper";

const piecesService = {
  getAll,
  getById,
  post,
  update,
  delete: _delete,
  count,
};

function getAll(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`pieces/?${queryString}`);
}

function getById(id) {
  return fetchWrapper.get(`pieces/${id}`);
}

function post(data) {
  return fetchWrapper.post("pieces/", data);
}

function update(id, params) {
  return fetchWrapper.put(`pieces/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`pieces/${id}`);
}

function count() {
  return fetchWrapper.get(`pieces/count`);
}

export default piecesService;
